import { getAuth } from "firebase/auth"
import { useEffect, useState } from "react"
import fbConf from "../FirebaseConf"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { t } from "i18next"

const TimelockLabel = styled.p<{ $isMenuOpen: boolean }>`
  font-weight: 700;
  font-size: 12px;
  color: ${props => props.theme.colors.gray_600};
  margin: 0px;
  margin-left: 8px;
  width: ${props => props.$isMenuOpen ? 'auto' : '1px'};
`

export default function SignOutTimer({ isMenuOpen, triggerReset }: { isMenuOpen: boolean, triggerReset: number }) {
  const navigate = useNavigate()
  const [timelockSeconds, setTimelockSeconds] = useState<number>(60 * 60 * 16)

  // Announce reset to other tabs on load
  useEffect(() => {
    setTimelockSeconds(60 * 60 * 16)
    localStorage.setItem('timeLockReset', Date.now().toString())
  }, [])

  // Listen to resets from other tabs
  useEffect(() => {
    function handleStorage(e: any) {
      if (e.key === 'timeLockReset') {
        setTimelockSeconds(60 * 60 * 16)
      }
    }
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [])
  
  useEffect(() => {
    const timelockInterval = setTimeout(() => {
      if (timelockSeconds <= 0) {
        handleSignOut()
      } else {
        setTimelockSeconds(timelockSeconds - 1)
      }
    }, 1000)

    return () => clearTimeout(timelockInterval)
  }, [timelockSeconds])

  /*useEffect(() => {
    setTimelockSeconds(60 * 60)
  }, [location.pathname])*/

  useEffect(() => {
    setTimelockSeconds(60 * 60 * 16)
    localStorage.setItem('timeLockReset', Date.now().toString())
  }, [triggerReset])

  async function handleSignOut() {
    await getAuth(fbConf).signOut()
    localStorage.removeItem('token')
    navigate(`/login?redirect=${location.pathname}`)
  }

  return (
    <TimelockLabel $isMenuOpen={isMenuOpen}>
      {`${isMenuOpen ? `${t('app_timelock')}:` : ''}
        ${String(Math.floor(timelockSeconds / 3600)).padStart(2, '0')}:${String(Math.floor((timelockSeconds % 3600) / 60)).padStart(2, '0')}:${String(timelockSeconds % 60).padStart(2, '0')}`}
    </TimelockLabel>
  )
}